const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        let date = new Date;
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1e3),
        expires = "; expires=" + date.toUTCString()
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/"
}
  , getCookie = name => {
    for (var nameEQ = name + "=", ca = document.cookie.split(";"), i = 0; i < ca.length; i++) {
        for (var c = ca[i]; c.charAt(0) == " "; )
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length)
    }
    return null
}
;
function getBannerEl() {
    return document.getElementById("cookies-approval")
}
function showBanner() {
    getBannerEl().style.display = "block"
}
function hideBanner() {
    getBannerEl().style.display = "none"
}
function handleAccept(e) {
    setCookie("accept-cookies", "true", 30),
    hideBanner()
}
function initCookieBanner() {
    getCookie("accept-cookies") || showBanner()
}
window.Shopify.loadFeatures([{
    name: "consent-tracking-api",
    version: "0.1"
}], function(error) {
    if (error)
        throw error;
    initCookieBanner()
});